module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.redefine.js
// module id = 620
// module chunks = 0